import { ActionsMetadataV2, Link, Resource, ResourceLinks, ResourceMap } from 'medialoopster/rest';

/**
 * The Links of an annotation fetched from API Verison 2
 */
interface AnnotationLinks extends ResourceLinks<'annotation'> {
  readonly 'http://medialoopster.com/relations/asset': Link;
  readonly 'http://medialoopster.com/relations/user': Link;
}

/**
 * Annotation for a video asset.
 *
 * This models the annotation resource in API Version 2
 */
export interface Annotation extends Resource<'annotation', AnnotationLinks> {
  readonly user: string;
  readonly date_add: string;
  readonly time: number;
  readonly text: string;
  readonly is_public: boolean;
}

/**
 * The root state for the annotation duck.
 */
export interface AnnotationRootState {
  readonly annotations: ResourceMap<Annotation>;
  readonly annotationEndpointLink: Link | null;
  readonly publishAnnotationsLink: Link | null;
  readonly unpublishAnnotationsLink: Link | null;
  readonly deleteAnnotationsLink: Link | null;
  readonly hasAnnotationPermission: boolean;
}

export const FETCH_ANNOTATION_OPTIONS = 'FRONTEND/DETAIL_SECTION/FETCH_ANNOTATION_OPTIONS';
export const ANNOTATION_OPTIONS_LOADED = 'FRONTEND/DETAIL_SECTION/ANNOTATION_OPTIONS_LOADED';

export interface FetchAnnotationOptions {
  readonly type: typeof FETCH_ANNOTATION_OPTIONS;
}

export interface AnnotationOptionsLoaded {
  readonly type: typeof ANNOTATION_OPTIONS_LOADED;
  readonly payload: {
    readonly actions: ActionsMetadataV2;
  };
}
